import { styled } from '@mui/material/styles';

export const AccordionContainer = styled('div')({
  marginBottom: '6px'
});
